import React, {useContext} from 'react';
import { ask__ } from './../../shared/utils/i18n.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import "./Error.scss";

export default function Error() {

  const {isGlobalError} = useContext(GlobalErrorContext);

  return (
    <div className="error">
      <div className="error__inner">

        <h2>{ ask__('Error: Title') !== 'Error: Title' ? ask__('Error: Title') : 'System error'  }</h2>
        <p>{ ask__('Error: Generic') !== 'Error: Generic' ? ask__('Error: Generic') : 'Try to refresh the page or contact us by other means.' }</p>
        <p>{ ask__('Error: Code') !== 'Error: Code' ? ask__('Error: Code') : 'Error code' }: <strong>{isGlobalError.errorCode}</strong></p>
        <button
          onClick={e => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          { ask__('Error: Refresh') !== 'Error: Refresh' ? ask__('Error: Refresh') : 'Refresh'  }
        </button>

      </div>
    </div>
  )

}
